// Business Information
export const businessInfo = {
  name: "Genuine Fencers",
  phone: "+61 414 443 454",
  email: "gfencers@outlook.com",
  hours: {
    weekdays: "Monday to Saturday, 7:00 AM – 5:00 PM",
    sunday: "Closed"
  },
  location: "Sydney, NSW, Australia"
};

// Project Images from uploaded assets
export const projectImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_hipages-reviews/artifacts/mlpb227k_WhatsApp%20Image%202026-05-28%20at%2011.12.54%20AM.jpeg",
    category: "balustrade",
    title: "Curved Facade Dark Glass Balustrade",
    description: "Modern curved facade with premium dark glass balustrade",
    featured: true
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_hipages-reviews/artifacts/npd2m20k_WhatsApp%20Image%202026-05-28%20at%2011.08.12%20AM.jpeg",
    category: "pool-fencing",
    title: "Frameless Pool Fence with Tropical Garden",
    description: "Frameless glass pool fence surrounded by lush tropical landscaping"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_hipages-reviews/artifacts/68o60lii_WhatsApp%20Image%202026-05-28%20at%2011.07.09%20AM.jpeg",
    category: "pool-fencing",
    title: "Frameless Pool Fence on Hardwood Deck",
    description: "Premium frameless glass pool fencing on hardwood decking"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_hipages-reviews/artifacts/ombip5lr_WhatsApp%20Image%202026-05-28%20at%2010.43.33%20AM.jpeg",
    category: "pool-fencing",
    title: "Glass Pool Fence with Black Steel Handrail",
    description: "Glass pool fence featuring sleek black steel handrail detail"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_hipages-reviews/artifacts/cqg2qms2_WhatsApp%20Image%202026-05-28%20at%2011.05.08%20AM.jpeg",
    category: "pool-fencing",
    title: "Frameless Glass Fence on Travertine",
    description: "Frameless glass pool fence on premium travertine surrounds"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_frameless-fencing/artifacts/5wwdjzyw_WhatsApp%20Image%202026-04-06%20at%207.43.30%20PM.jpeg",
    category: "fencing",
    title: "Modern Slat Fencing",
    description: "Contemporary black slat fencing installation"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_frameless-fencing/artifacts/ymndh886_WhatsApp%20Image%202026-04-06%20at%207.43.31%20PM%20%281%29.jpeg",
    category: "balustrade",
    title: "Glass Staircase Balustrade",
    description: "Elegant glass balustrade with wooden steps"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_frameless-fencing/artifacts/f8yydnlx_WhatsApp%20Image%202026-04-06%20at%207.43.31%20PM.jpeg",
    category: "pool-fencing",
    title: "Frameless Glass Pool Fencing",
    description: "Frameless glass pool fence with scenic views"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_frameless-fencing/artifacts/ueziz642_WhatsApp%20Image%202026-04-06%20at%207.43.33%20PM.jpeg",
    category: "pool-fencing",
    title: "Premium Pool Fencing",
    description: "Glass pool fencing with modern architecture"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_frameless-fencing/artifacts/aps8y43e_WhatsApp%20Image%202026-04-06%20at%207.43.34%20PM%20%281%29.jpeg",
    category: "shower",
    title: "Glass Shower Screen",
    description: "Minimalist glass shower installation"
  }
];

// Services Data
export const services = [
  {
    id: 1,
    title: "Glass Pool Fencing",
    description: "Frameless and semi-frameless glass pool fencing that combines safety with unobstructed views. Compliant with Australian safety standards.",
    features: [
      "Frameless & semi-frameless options",
      "12mm toughened safety glass",
      "Australian standards compliant",
      "Stainless steel spigots"
    ],
    icon: "Waves"
  },
  {
    id: 2,
    title: "Glass Balustrades",
    description: "Premium glass balustrades for balconies, staircases, and decks. Modern designs that enhance your property's aesthetics.",
    features: [
      "Balcony & staircase installations",
      "Frameless & framed systems",
      "Custom heights & finishes",
      "Weather-resistant hardware"
    ],
    icon: "Building"
  },
  {
    id: 3,
    title: "Aluminum Fencing, Louvers & Screens",
    description: "Durable aluminum fencing, decorative louvers, and privacy screens. Modern solutions that combine style, strength, and low maintenance.",
    features: [
      "Powder-coated aluminum finishes",
      "Custom slat designs & patterns",
      "Privacy screens & louver systems",
      "Weather & rust resistant"
    ],
    icon: "Fence"
  },
  {
    id: 4,
    title: "Custom Glass Panels",
    description: "Bespoke glass solutions for residential and commercial projects. From shower screens to privacy panels.",
    features: [
      "Made-to-measure panels",
      "Various glass types & tints",
      "Privacy & decorative options",
      "Commercial & residential"
    ],
    icon: "Square"
  },
  {
    id: 5,
    title: "Supply & Installation",
    description: "Complete end-to-end service from consultation to installation. Professional team with years of experience.",
    features: [
      "Free on-site consultation",
      "Professional installation",
      "Quality guaranteed",
      "After-sales support"
    ],
    icon: "Wrench"
  }
];

// Real Hipages Reviews
export const hipagesReviews = [
  {
    id: 1,
    name: "Kimberley W",
    location: "Erskineville, NSW",
    rating: 5,
    date: "14 May 2026",
    text: "Genuine Fencers were quick, professional, competitive, and great at communicating.",
    category: "Glass Balustrades",
    verified: true,
    hired: true
  },
  {
    id: 2,
    name: "Phil M",
    location: "Glenfield, NSW",
    rating: 5,
    date: "1 May 2026",
    text: "Quality work and very easy to communicate with. They were very reliable and did a fantastic job.",
    category: "Pool Fencing Installation",
    verified: true,
    hired: true
  },
  {
    id: 3,
    name: "Nick M",
    location: "Chatswood, NSW",
    rating: 5,
    date: "1 Mar 2026",
    text: "Genuine Fencers were a pleasure to work with. Excellent communication and competitive pricing. Our pool fence was completed within days of the quote and the quality of their work is excellent. Excellent customer service ethic, highly recommended.",
    category: "Glass Pool Fencing",
    verified: true,
    hired: true
  },
  {
    id: 4,
    name: "Ghassan A",
    location: "Bossley Park, NSW",
    rating: 5,
    date: "8 Sep 2025",
    text: "Connected with Genuine Fencers and would recommend them.",
    category: "Glass Balustrades",
    verified: true,
    hired: false
  },
  {
    id: 5,
    name: "Mr C",
    location: "North Turramurra, NSW",
    rating: 5,
    date: "3 Sep 2025",
    text: "The team did a fantastic job installing a new glass balustrade on our staircase.",
    category: "Glass Balustrades",
    verified: true,
    hired: true
  }
];

// Hipages Stats
export const hipagesStats = {
  averageRating: 5.0,
  totalRatings: 17,
  recommendations: 19,
  hires: 34,
  profileUrl: "https://hipages.com.au/connect/ahmedfakih",
  starBreakdown: {
    5: 17,
    4: 0,
    3: 0,
    2: 0,
    1: 0
  }
};

// FAQ Data
export const faqs = [
  {
    question: "Do you provide free quotes?",
    answer: "Yes, we offer free on-site consultations and quotes. Contact us to arrange a visit at your convenience."
  },
  {
    question: "Are your glass installations compliant with Australian standards?",
    answer: "Absolutely. All our glass pool fencing and balustrades meet Australian safety standards (AS 1926.1-2012 for pool fencing)."
  },
  {
    question: "How long does installation take?",
    answer: "Most residential installations are completed within 1-2 days, depending on the project size. We'll provide a specific timeline during your consultation."
  },
  {
    question: "What areas in Sydney do you service?",
    answer: "We service all Sydney metropolitan areas including Eastern Suburbs, North Shore, Inner West, and surrounding regions."
  },
  {
    question: "Do you offer warranties?",
    answer: "Yes, we provide warranties on both materials and workmanship. Specific warranty terms will be outlined in your quote."
  },
  {
    question: "Can I choose different glass types?",
    answer: "Yes, we offer various glass options including clear, tinted, frosted, and patterned glass to suit your privacy and aesthetic preferences."
  }
];
